export type Filters<K extends string> = {
  [key in K]: string[]
}

export const filtersDefault = <K extends string>(...keys: K[]): Filters<K> => {
  const result: Record<string, string[]> = {}
  for (const key of keys) result[key] = []
  return result as Filters<K>
}
